<div class="panel-content demiPanel">

    <h3 class="toolname">
      <img class="bottom" src="/assets/img/dem/dem_tool_icon_v1.png" />
        {{demObject.name}}
    </h3>
    <div class="logo-heading"></div>


  <div class="dem-area" *ngIf="demObject">
    <ul>
      <li>
        <label>Coverage Size</label>
        <p>{{demObject.coverage_size}} ac</p>
      </li>
      <li>
        <label>Coordinates (Centroid)</label>
        <p>{{demObject.centroid}}</p>
      </li>
      <li>
        <label>Horizontal Resolution</label>
        <p>{{demObject.horizontal_resolution}}</p>
      </li>
      <li>
        <label>Vertical Resolution</label>
        <p>{{demObject.vertical_resolution}}</p>
      </li>
      <li>
        <label>Output Dimensions</label>
        <p>{{demObject.width}} x {{demObject.height}} pixels</p>
      </li>
      <li>
        <label>Coordinate System</label>
        <p>Web Mercator EPSG:3857</p>
      </li>
      <li>
        <label>Estimated File Size</label>
        <p>{{demObject.estimated_file_size}}</p>
      </li>
    </ul>


  </div>
  <div class="download-button" *ngIf="demObject">
    <button class="submit" style="margin-left: 10px;" (click)="downloadTiffFile(demObject.tiff_filename)">Download</button>
    <div class="processing">
      <img alt="loader" src="../../../../../../assets/img/dem-download.svg" (click)="downloadTiffFile(demObject.tiff_filename)">
      <p>{{demObject.estimated_file_size}}</p>
    </div>
  </div>
</div>
<div class="btn">
  <a class="closer button closerToolTip4" (click)="clickToZoom()">
    <img class="save-img common-btns tool-toolTip4" src="/assets/img/tools/zoom-to.png"
      alt="closer" /><span class="tooltiptext4" [innerHtml]="
      mapService.templatetoolTips['zoom_to_selection_right_panel']
      "></span></a>
      <a class="closer button" [tooltip]="deleteTip" [options]="myDelete" (click)="deleteDEM(demObject.id)">
        <img
          class="delete_data common-btns"
          src="/assets/img/table/addRedX2.png"
          alt="back"
      /></a>
  <a class="closer button closerToolTip1">
    <img (click)="goBack()" class="back-img common-btns tool-toolTip1"
        src="/assets/img/tools/back-pv3.png" alt="back" /><span class="tooltiptext1"
        [innerHtml]="mapService.templatetoolTips['back_right_panel']"></span></a>
  <a
    class="closer button"
    [tooltip]="mapService.templatetoolTips['close_right_panel']"
    [options]="myOptions15"
  >
    <img
    (click)="closeRightpanel()"
      class="closer-img common-btns"
      src="/assets/img/tools/close-pv3.png"
      alt="closer"
  /></a>
</div>
<ngx-spinner [fullScreen]="true" type="" size="medium" bdColor="rgba(0, 0, 0, 0)">
  <p class="loading" > <img src="/assets/img/wheel.svg" alt="Girl in a jacket" width="50px" height="50px" > </p>
  </ngx-spinner>
